export default __webpack_public_path__ + "static/media/carretilla-elevadora.e994e459.jpg";